import { Mapper } from '../base-mapper';
import { GetResultOWASReportDTO } from '@/core/dto/owas-report';
import {
	GetResultOWASReport,
	InformationsResult,
	GeneralInformationsResult,
	ActivityRiskResult,
	TasksResult
} from '@/core/domain/owas-report';

const NONE_RISK_RESULT = 0;
const ACCEPTABLE_RISK_RESULT = 1;
const MODERATE_RISK_RESULT = 2;
const VERY_HIGH_RISK_RESULT = 4;
const SERIOUS_RISK_RESULT = 5;
const OWAS_RESULT_MAPPER = [ACCEPTABLE_RISK_RESULT, MODERATE_RISK_RESULT, VERY_HIGH_RISK_RESULT, SERIOUS_RISK_RESULT];

export class GetResultOWASReportMapper extends Mapper<GetResultOWASReport> {
	constructor(private readonly data: GetResultOWASReportDTO) {
		super();
	}

	private getResult(): number {
		const mostSeriousRisks = this.data?.overall_activity_task?.most_serious_risk_tasks;
		const worstRiskScore = mostSeriousRisks[0]?.score;

		if (!worstRiskScore || !mostSeriousRisks || mostSeriousRisks.length === 0) {
			return NONE_RISK_RESULT;
		}

		return OWAS_RESULT_MAPPER[worstRiskScore - 1];
	}

	toDomain(): GetResultOWASReport {
		return new GetResultOWASReport({
			result: this.getResult(),
			informations: new InformationsResult(this.data.informations),
			general_informations: new GeneralInformationsResult(this.data.general_informations),
			overall_activity_task: new ActivityRiskResult(this.data.overall_activity_task),
			tasks: this.data.tasks?.map((value) => new TasksResult(value))
		});
	}
}
